import React from "react";

const Ruray = () => {
  return (
    <div className="container mt-5 mb-5" style={{ fontFamily: 'Arial, sans-serif', color: '#333', lineHeight: '1.6' }}>
      
      {/* SECCIÓN DE POLÍTICA DE PRIVACIDAD - Requerida por Google Play */}
      <section id="politica-privacidad" className="mb-5 p-4" style={{ backgroundColor: '#f4f4f4', borderRadius: '10px', border: '1px solid #ddd' }}>
        <h1 style={{ color: '#000' }}>Política de Privacidad</h1>
        <p><strong>Última actualización:</strong> 15 de enero 2026</p>
        <hr />
        <p>
          En <strong>Ruray</strong>, nos tomamos muy en serio la protección de sus datos personales. Esta Política de Privacidad explica cómo recopilamos y tratamos su información al utilizar nuestra aplicación.
        </p>
        
        <h3>1. Recopilación de Información</h3>
        <p>
          Recopilamos información personal que usted nos proporciona voluntariamente, como su nombre, dirección de correo electrónico y otros datos necesarios para el registro y la validación de seguridad dentro de la plataforma.
        </p>

        <h3>2. Uso de los Datos</h3>
        <p>
          Su información se utiliza exclusivamente para proporcionar los servicios de la aplicación, mejorar la experiencia del usuario, realizar validaciones de identidad y mantener la seguridad de su cuenta.
        </p>

        <h3>3. Confidencialidad y Seguridad</h3>
        <p>
          Ruray garantiza que la información personal enviada cuenta con la seguridad necesaria. Nos comprometemos a no vender, alquilar ni entregar sus datos personales a terceros sin su consentimiento explícito, salvo por requerimiento legal.
        </p>

        <h3>4. Eliminación de Datos</h3>
        <p>
          Los usuarios pueden solicitar la eliminación de su cuenta y sus datos personales en cualquier momento a través de la configuración de la aplicación o contactándonos directamente.
        </p>
      </section>

      <hr style={{ margin: '40px 0' }} />

      {/* SECCIÓN DE TÉRMINOS Y CONDICIONES - Tu texto original */}
      <section id="terminos-condiciones">
        <h1>Términos y Condiciones de Uso</h1>
        <p>Actualizado 2022-06-22</p>
        <p>
          Al acceder al app de Ruray usted confirma que está de acuerdo y sujeto a
          los términos de servicio contenidos en los Términos y condiciones que
          se describen a continuación. Estos términos se aplican a todo el sitio
          web, app y a cualquier correo electrónico u otro tipo de comunicación
          entre usted y Ruray. Bajo ninguna circunstancia el equipo de Ruray será
          responsable de ningún daño directo, indirecto especial, usted asume los
          costos de los mismos. Ruray no será responsable de ningún resultado que
          pueda ocurrir durante el uso de uno de nuestros recursos. Nos reservamos
          el derecho de cambiar y revisar la política de uso en cualquier momento.
        </p>
        <p>
          <strong>Modificaciones a nuestra plataforma:</strong> Ruray se reserva el derecho de
          modificar, suspender o interrumpir, temporal o permanentemente, la
          platforma o cualquier servicio al que se conecte, con o sin previo
          aviso y sin responsabilidad ante usted. 
          <br /><br />
          <strong>Actualizaciones a nuestra plataforma:</strong> Ruray puede, de vez en cuando, proporcionar mejoras a las
          características / funcionalidad de la plataforma, que pueden incluir
          parches, corrección de errores, actualizaciones, mejoras y otras
          modificaciones ("Actualizaciones"). Las actualizaciones pueden modificar
          o eliminar ciertas características y/o funcionalidades de la plataforma.
          Usted acepta que Ruray no tiene la obligación de (1) proporcionar
          Actualizaciones, o (1) continuar proporcionándole o habilitando
          características y/o funcionalidades particulares de la plataforma.
          Además, acepta que todas las Actualizaciones (1) se considerarán una
          parte integral de la plataforma y (ii) estarán sujetas a los términos y
          condiciones de este Acuerdo.
        </p>
        <p>
          Ruray, garantiza que la información personal que usted envía cuenta con
          la seguridad necesaria. Los datos ingresados por usuario o en el caso de
          requerir una validación no serán entregados a terceros.
        </p>
        <p>
          La suscripción a boletines de correos electrónicos publicitarios es
          voluntaria.
        </p>
      </section>
    </div>
  );
};

export default Ruray;